var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "analysisEvent" }, [
    _c(
      "header",
      [
        _c(
          "el-select",
          {
            staticClass: "group",
            attrs: {
              placeholder: _vm.$t("Analysis.Event.select_group"),
              size: "small",
              multiple: "",
            },
            model: {
              value: _vm.params.groups,
              callback: function ($$v) {
                _vm.$set(_vm.params, "groups", $$v)
              },
              expression: "params.groups",
            },
          },
          _vm._l(_vm.groups, function (group) {
            return _c("el-option", {
              key: group.id,
              attrs: { label: group.name, value: group.id },
            })
          }),
          1
        ),
        _c(
          "el-select",
          {
            staticClass: "event",
            attrs: {
              placeholder: _vm.$t("Analysis.Event.select_event"),
              size: "small",
              multiple: "",
            },
            model: {
              value: _vm.params.events,
              callback: function ($$v) {
                _vm.$set(_vm.params, "events", $$v)
              },
              expression: "params.events",
            },
          },
          _vm._l(_vm.events, function (event) {
            return _c("el-option", {
              key: event.id,
              attrs: { label: event.name, value: event.id },
            })
          }),
          1
        ),
        _c("el-date-picker", {
          staticClass: "picker",
          attrs: {
            type: "daterange",
            size: "small",
            align: "right",
            "unlink-panels": "",
            "range-separator": "〜",
            "start-placeholder": _vm.$t("Analysis.start_date"),
            "end-placeholder": _vm.$t("Analysis.end_date"),
            "picker-options": _vm.options,
            "value-format": "yyyy-MM-dd",
          },
          model: {
            value: _vm.params.daterange,
            callback: function ($$v) {
              _vm.$set(_vm.params, "daterange", $$v)
            },
            expression: "params.daterange",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { attrs: { id: "graphs" } },
      [
        _c(
          "div",
          { staticClass: "action-graph" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.Event.title01")))]),
            _c("el-switch", {
              staticClass: "mode",
              attrs: {
                "active-color": "#009CE1",
                "inactive-color": "#009CE1",
                "active-text": _vm.$t("Analysis.Event.rate"),
                "inactive-text": _vm.$t("Analysis.Event.number"),
              },
              model: {
                value: _vm.modeActionType,
                callback: function ($$v) {
                  _vm.modeActionType = $$v
                },
                expression: "modeActionType",
              },
            }),
            _c("Event", {
              attrs: {
                height: 320,
                eventCountsByActionTypeByDay:
                  _vm.api.eventCountsByActionTypeByDay,
                percentageMode: _vm.modeActionType,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "event-graph" },
          [
            _c("h1", [
              _vm._v(_vm._s(_vm.$t("Analysis.Event.title-event-graph"))),
            ]),
            _c("el-switch", {
              staticClass: "mode",
              attrs: {
                "active-color": "#009CE1",
                "inactive-color": "#009CE1",
                "active-text": _vm.$t("Analysis.Event.rate"),
                "inactive-text": _vm.$t("Analysis.Event.number"),
              },
              model: {
                value: _vm.modeEvent,
                callback: function ($$v) {
                  _vm.modeEvent = $$v
                },
                expression: "modeEvent",
              },
            }),
            _c("counts-by-event", {
              attrs: {
                height: 320,
                eventCountsByEventByDay: _vm.api.eventCountsByEventByDay,
                eventList: _vm.api.eventList,
                percentageMode: _vm.modeEvent,
              },
            }),
          ],
          1
        ),
        _c("EventList", {
          attrs: {
            actions: _vm.params.actions,
            groups: _vm.params.groups,
            daterange: _vm.params.daterange,
            eventFilters: _vm.params.events,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }